export class DateFormatterUtils {
  formatHourMinuteSecond(date: Date): string {
    if (date) {
      return date.toLocaleString('en-US', {
        weekday: 'short',
        month: '2-digit',
        day: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      });
    }
    return '';
  }
}
